export default "__VITE_ASSET__DgSI8ibK__"